import React from "react";
import { Button, Card, CardContent, Typography, Box } from "@mui/material";
import { Download } from "@mui/icons-material";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactLogo from "././Assets/ReactLogo/ReactLogo.png";
import EdsomLogo from "././Assets/ReactLogo/EdsomLogo.png";

// Define user data with unique gradients
const users = [
  {
    name: "Kamran Aslam Khan",
    role: "React.js Developer",
    company: "Edsom Fintech Pvt. Ltd.",
    gradient: "linear-gradient(135deg, #00c6ff, #0072ff)", // Your gradient
  },
  {
    name: "John Doe",
    role: "Frontend Developer",
    company: "Tech Solutions Inc.",
    gradient: "linear-gradient(135deg, #ff7e5f, #feb47b)", // Gradient for John
  },
  {
    name: "Jane Smith",
    role: "UI/UX Designer",
    company: "Creative Designs Ltd.",
    gradient: "linear-gradient(135deg, #6a11cb, #2575fc)", // Gradient for Jane
  },
  {
    name: "Alice Johnson",
    role: "Full Stack Developer",
    company: "Innovate Tech",
    gradient: "linear-gradient(135deg, #43e97b, #38f9d7)", // Gradient for Alice
  },
];

const DeskCard = () => {
  const handleDownloadPDF = async () => {
    const cardElements = document.querySelectorAll(".desk-card"); // Select all card elements

    if (cardElements.length > 0) {
      const pdf = new jsPDF("p", "mm", "a4"); // Create a new PDF in A4 size
      const imgWidth = 120; // Width of the image in the PDF
      let yOffset = 10; // Initial Y offset for the first card

      for (let i = 0; i < cardElements.length; i++) {
        const cardElement = cardElements[i];
        const canvas = await html2canvas(cardElement, {
          scale: 2, // Increase scale for better quality
          useCORS: true, // Allow cross-origin images
          logging: true, // Enable logging for debugging
        });

        const imgData = canvas.toDataURL("image/png", 1.0); // Convert canvas to image
        const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

        // Add the image to the PDF
        pdf.addImage(imgData, "PNG", (pdf.internal.pageSize.getWidth() - imgWidth) / 2, yOffset, imgWidth, imgHeight);

        yOffset += imgHeight + 10; // Update Y offset for the next card

        // Add a new page if the current card doesn't fit
        if (yOffset + imgHeight > pdf.internal.pageSize.getHeight() && i < cardElements.length - 1) {
          pdf.addPage();
          yOffset = 10; // Reset Y offset for the new page
        }
      }

      pdf.save("all-cards.pdf"); // Download the PDF
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column", // Stack cards vertically
        justifyContent: "center",
        alignItems: "center",
        gap: "20px", // Space between cards
        minHeight: "100vh", // Center the cards vertically
        padding: "20px", // Add padding for better spacing
      }}
    >
      {users.map((user, index) => (
        <Card
          key={index}
          className="desk-card"
          sx={{
            width: "400px",
            padding: "20px",
            borderRadius: "15px",
            boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)",
            background: user.gradient, // Unique gradient for each user
          }}
        >
          <CardContent
            sx={{
              textAlign: "center",
            }}
          >
            <Box
              sx={{
                background: "rgba(255, 255, 255, 0.8)", // Semi-transparent white background for text
                padding: "10px",
                borderRadius: "10px",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "bold",
                  color: "#333", // Your name color remains consistent
                  marginBottom: "10px",
                }}
              >
                {user.name}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px", // Space between logo and text
                  marginBottom: "30px",
                }}
              >
                <img
                  src={ReactLogo}
                  alt="React Logo"
                  style={{ width: "30px", height: "30px" }} // React logo size
                />
                <Typography
                  variant="h5"
                  sx={{
                    color: "#555",
                  }}
                >
                  {user.role}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px", // Space between logo and text
                }}
              >
                <img
                  src={EdsomLogo}
                  alt="Edsom Logo"
                  style={{ width: "30px", height: "30px" }} // Edsom logo size
                />
                <Typography
                  variant="h6"
                  sx={{
                    color: "#777",
                  }}
                >
                  {user.company}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      ))}
      <Button
        variant="contained"
        startIcon={<Download />}
        onClick={handleDownloadPDF}
        sx={{
          marginTop: "20px",
          background: "linear-gradient(135deg, #00c6ff, #0072ff)", // Gradient for the button
          color: "#fff",
          "&:hover": {
            background: "linear-gradient(135deg, #0072ff, #00c6ff)", // Hover effect
          },
          position: "absolute",
          bottom: "20px",
        }}
      >
        Download as PDF
      </Button>
    </Box>
  );
};

export default DeskCard;
